import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { AppGlobalContext } from "../contexts/AppContext.context";

// Sidebar width
import { SIDEBAR_MENU_CONFIG } from "../components/SideBar/SidebarMenu.config";

// Header and Sidebar component
import HeaderV2 from "../components/Header/Header_V2";
import SidebarV2 from "../components/SideBar/Sidebar_V2";
import SidebarLogo from "../components/SideBar/SidebarLogo";

// Sub Header component
import SubHeaderComponent from "../components/Header/SubHeaderComponent";

const drawerWidth = SIDEBAR_MENU_CONFIG.sidebar_width;

// Main component css and style
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    paddingTop: 0,
    height: "100vh",
    marginLeft: `-${drawerWidth}px`,
    width: "100%",
    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: 0,
    }),
  })
);

const Layout = ({ children, isSubHeaderVisible, subHeaderTitle, isSearchBarVisible, showBackButton }) => {
  let isTabletMid = useMediaQuery("(max-width: 780px)");
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const { subHeaderBackHandler } = useContext(AppGlobalContext);
  // useEffect(() => {
  //   if (isTabletMid) {
  //     setOpen(false);
  //   } else {
  //     setOpen(true);
  //   }
  // }, [isTabletMid]);

  useEffect(() => {
    if (isTabletMid) {
      setOpen(false);
    }
  }, [isTabletMid]);

  useEffect(() => {
    isTabletMid && setOpen(false);
  }, [pathname, isTabletMid]);

  const handleSideBarToggle = () => {
    setOpen((e) => !e);
  };

  const SideBarVariantProps =
    isTabletMid && open ? {} : { variant: "persistent" };

  return (
    <Box style={{ display: "flex" }}>
      <Drawer
        open={open}
        onClose={handleSideBarToggle}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        {...SideBarVariantProps}
      >
        {/* This is Sidebar Logo */}
        <SidebarLogo InSidebar={true} />

        {/* This is the sidebar */}
        <SidebarV2 />
      </Drawer>
      <Main open={open}>
        {/* Fixed Header */}
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1100,
          }}
        >
          <HeaderV2 onMenuClick={handleSideBarToggle} />
          <SubHeaderComponent
            title={subHeaderTitle}
            isSubHeaderVisible={isSubHeaderVisible}
            backButtonHandler={subHeaderBackHandler}
            isSearchBarVisible={isSearchBarVisible}
            backButton={showBackButton}
          />
        </div>

        {/* Scrollable Content */}
        <div
          style={{
            height: isSubHeaderVisible ? "calc(100vh - 150px)" : "calc(100vh - 90px)",
            overflowY: "auto",
            paddingTop: 10,
            padding: "12px 16px",
          }}
        >
          {children}
        </div>
      </Main>
    </Box>
  );
};

export default Layout;